import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client, { imgUrl, shuffled } from "@/lib/glossyApi";
import MiniAd from "@/components/MiniAd";
import MagazineLayout from "@/components/MagazineLayout";
import { Reveal } from "@/components/Reveal";

export default function MembersDesk() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { document.title = "The Members' Desk — S/ME"; client.get("/articles?type=blog").then((r) => setPosts(shuffled(r.data))).catch(() => {}); }, []);

  return (
    <MagazineLayout>
      <div className="pt-[68px] bg-cream min-h-screen">
        <header className="px-5 sm:px-8 pt-16 sm:pt-24 pb-10 max-w-[1600px] mx-auto">
          <p className="overline text-gloss-silver mb-4">Columns</p>
          <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-none">The Members' Desk</h1>
          <p className="font-sans text-lg text-ink/70 mt-5 max-w-xl">Expert columns written by S/ME members — the people who actually do the work, sharing what they know.</p>
          <div className="mt-8 max-w-3xl border-l-2 border-gloss-gold bg-secondary/60 px-6 py-5" data-testid="desk-seo-note">
            <p className="overline text-gloss-gold mb-2">A column is an SEO + GEO win</p>
            <p className="font-sans text-sm text-ink/70 leading-relaxed">Every column publishes as its own indexed, AI-readable page in the author's name — real, quotable expertise that helps them get found on Google and cited by AI answer engines. It's one more asset on top of a member's full S/ME presence (feature, profile, advert and Directory listing), all working together to grow their visibility.</p>
          </div>
        </header>
        <div className="px-5 sm:px-8 max-w-[1600px] mx-auto mb-10"><MiniAd variant="banner" space="desk_banner" /></div>
        <section className="px-5 sm:px-8 pb-28 max-w-[1600px] mx-auto">
          {posts.length === 0 ? (
            <p className="font-sans text-ink/50 py-20 text-center">No columns published yet.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14 border-t border-ink/20 pt-12">
              {posts.map((a, i) => (
                <Reveal key={a.id} delay={(i % 3) * 0.06}>
                  <Link to={`/read/${a.slug}`} className="group block" data-testid="blog-card">
                    <div className="relative overflow-hidden aspect-[4/3] bg-ink">
                      <img src={imgUrl(a)} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <p className="overline text-gloss-silver mt-5">{a.byline || a.author}</p>
                    <h3 className="font-serif text-2xl sm:text-3xl tracking-tight mt-1.5 leading-tight">{a.title}</h3>
                    <p className="font-sans text-base text-ink/70 mt-2.5 leading-relaxed">{a.dek}</p>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </section>
      </div>
    </MagazineLayout>
  );
}
